import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import TopHeader from "./TopHeader";
import TopMenuBar from "./TopMenuBar";
import PermissionGate from "@/components/auth/PermissionGate";
import ConsoleAccessBanner from "@/components/layout/ConsoleAccessBanner";
import { useAuth } from "@/contexts/AuthContext";
import { useCurrency } from "@/hooks/useCurrency";
import { isMinimalStaff } from "@/lib/permissions";
import { cn } from "@/lib/utils";

export default function AppShell() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  useCurrency(); // keep format.js defaults synced for print/export helpers
  const permissions = user?.permissions || [];

  const posFullscreen = pathname === "/pos";
  const minimalChrome =
    posFullscreen
    || pathname === "/waiter"
    || pathname === "/tables"
    || (pathname === "/kds" && isMinimalStaff(permissions));

  return (
    <PermissionGate>
      <div
        className={cn(
          "flex h-screen overflow-hidden",
          posFullscreen ? "bg-white" : "bg-[#EFE6DE]",
        )}
        data-testid="app-shell"
      >
        <div className="flex-1 flex flex-col min-w-0">
          <ConsoleAccessBanner />
          {!minimalChrome && <TopMenuBar />}
          {!minimalChrome && <TopHeader />}
          <main
            className={cn(
              "flex-1 min-h-0 min-w-0",
              posFullscreen || pathname === "/kds" || pathname === "/waiter" || pathname === "/tables"
                ? "overflow-hidden flex flex-col"
                : "overflow-x-hidden overflow-y-auto",
            )}
            data-testid="main-content"
          >
            <Outlet />
          </main>
        </div>
      </div>
    </PermissionGate>
  );
}
